import { Collapse as CollapseAntd } from 'antd'
import { TYPOGRAPHY_WEIGHT } from '../../../../components/Typography'
import Typography from '../../../../components/Typography/Typography'
import { Collapse } from '../../../../components/Collapse'
import { useEffect, useRef, useState } from 'react'
import { Loader } from '../Loader'
import { useLedByGPOListContext } from './LedByGPOContextProvider'
import { LedByGPOTable } from './LedByGPOTable'
import { Empty } from '../Empty'
import { EditFeesPopup } from './EditFeesPopup'

const { Panel } = CollapseAntd

export const LedByGPOList = ({ search }: { search: string }) => {
  const { state, actions } = useLedByGPOListContext()
  const { ledByGPOList: list, isLoading: loading } = state
  const { handleLoadMore: onLoadMore } = actions
  const sentinelRef = useRef(null)
  const [activeKey, setActiveKey] = useState('')
  const onChange = (uuid) => setActiveKey(uuid)

  useEffect(() => {
    actions.setSearch(search)
    setActiveKey('')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search])

  useEffect(() => {
    if (list.length && !activeKey) setActiveKey(list[0].gpo.uuid)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list])

  useEffect(() => {
    const sentinelElement = sentinelRef.current
    if (!sentinelElement) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          onLoadMore()
        }
      },
      {
        root: null,
        rootMargin: '100px',
        threshold: 1.0
      }
    )
    observer.observe(sentinelElement)
    return () => {
      observer.unobserve(sentinelElement)
    }
  }, [onLoadMore])

  if (!loading && !list.length) return <Empty />

  return (
    <div>
      <Collapse activeKey={activeKey} onChange={onChange}>
        {list.map((listItem) => {
          return (
            <Panel
              key={listItem.gpo.uuid}
              header={
                <Typography.Headline6 weight={TYPOGRAPHY_WEIGHT.SEMI_BOLD}>
                  GPO: {listItem.gpo.name}
                </Typography.Headline6>
              }
            >
              <LedByGPOTable relations={listItem.relations} />
            </Panel>
          )
        })}
      </Collapse>
      <div ref={sentinelRef} style={{ height: '10px' }} />
      {loading && <Loader itemsLength={list.length} />}
      <EditFeesPopup />
    </div>
  )
}
